export const HISTORY_STATUS = {
  "-1": "Trừ coin fail",
  0: "Lỗi",
  1: "Đang trong lượt",
  2: "Đã xác nhận, nhận điểm",
};
